import { ImageHelper } from '@/helper/imageHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { Const } from '@/const';
import { HtmlHelper } from './htmlHelper';
import bwipjs from 'bwip-js';
import * as Encoding from 'encoding-japanese';

export class CodeHelper
{
    //static readonly BARCODE_FONT_FAMILY = "OCRB";
    static readonly BARCODE_MARGIN = 10;
    static readonly BARCODE_FONTSIZE = 20;

    // バーコードを生成して、base64文字列で画像を返す
    // 0: JAN(標準) (EAN-13)
    // 1: JAN(短縮) (EAN-8)
    // 2: 物流(標準) (ITF-14)
    // 3: 物流(拡張) (ITF)
    // 4: 物流(アドオン) (ITF)
    // 5: ITF (ITF)
    // 6: NW-7 (Codabar)
    // 7: CODE39 (CODE39)
    // 8: CODE128 (CODE128)
    // 9: GS1(標準)
    // 10: GS1(拡張)
    // 11: ISBN
    // 12: GS1-128
    public static createBarcode(barcodeType : number, text : string, showNumber : boolean, width : number, height : number)
    {
        if(width <= 0 || height <= 0) { return ""; }
        if(this.isGS1Barcode(barcodeType)) return this.createGS1(barcodeType, text, showNumber, width, height);
        try
        {
			// 先頭のBOMを削除
			text = this.removeStartBOMOfText(text);

            if(barcodeType != 7 && barcodeType != 8)
            {
                // 最後尾のスペースを削除 *CODE39, CODE128はスペースもバー化する
                text = this.removeEndSpaceOfText(text);
            }
            // Flatにする
            var isFlat = false;
            // 物流コードの桁数チェック
            if(barcodeType == 3)
            {
                // ITF-16
                if(text.length == 16 || text.length == 15) 
                {
                    // チェックデジットを計算
                    var digit = this.calcCheckDigitModulus10Weight3(text.substr(0, 15));
                    text = text.substr(0, 15) + digit;
                }
                else
                {
                    return "";
                }
            }
            else if(barcodeType == 4)
            {
                // ITF-6
                if(text.length == 6 || text.length == 5) 
                {
                    // チェックデジットを計算
                    var digit = this.calcCheckDigitModulus10Weight3(text.substr(0, 5));
                    text = text.substr(0, 5) + digit;
                }
                else
                {
                    return "";
                }
            }
            else if(barcodeType == 11)
            {
                // ISBN
                // フラット
                isFlat = true;
                // ハイフン削除
                text = text.replace(/-/g, "");
            }
            // else if(barcodeType == 0)
            // {
            //     // EAN-13
            //     if(text.length >= 3 && (text.substr(0, 3) == "978" || text.substr(0, 3) == "979"))
            //     {
            //         // ISBNコード
            //         isISBN = true;
            //         // ハイフン削除
            //         text = text.replace(/-/g, "");
            //     }
            //     else if(text.length >= 7 && (text.substr(0, 3) == "ISBN978" || text.substr(0, 3) == "ISBN979"))
            //     {
            //         // ISBNコード
            //         isISBN = true;
            //         // 文字列"ISBN"削除, ハイフン削除
            //         text = text.substr(4, text.length - 4).replace(/-/g, "");
            //     }
            //     else if(text.length >= 3 && (text.substr(0, 3) == "191" || text.substr(0, 3) == "192"))
            //     {
            //         // ISBNコード *2段目
            //         isISBN = true;
            //     }
            // }
            var JsBarcode = require('jsbarcode');
            // SVGに生成する前に、サイズを測るためにcanvasに生成
            var canvas = document.createElement("canvas");
            var format = CodeHelper.getFormatFromBarcodeType(barcodeType);
            var barcodeFontFamily = Const.FONT_FAMILY_OCRB;
            JsBarcode(canvas, text, { format : format, font : barcodeFontFamily, displayValue : showNumber, height : 100, flat : isFlat  } );
            // バーコードサイズ
            var codeWidth = canvas.width;
            var codeHeight = canvas.height;
            // 高さをこのバーコードサイズのスケールに直して、バーコードの高さに指定したい値を得る。
            var needHeight = height * codeWidth / width;
            // 実際のサイズとの差
            var deltaHeight = needHeight - codeHeight;
            var svg : SVGSVGElement;
            if(showNumber)
            {
                //** WebFontはAWSから取得できるので、常にSVGを使用する。
                //** レンダリングは同名のフォントを使用できる。
                // var lastCanvas = document.createElement("canvas");
                // JsBarcode(lastCanvas, text, { format : format, font : barcodeFontFamily, displayValue : showNumber, height : 100 + deltaHeight } );
                // // base64に変換
                // base64 = lastCanvas.toDataURL("image/png");
                svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                JsBarcode(svg, text, { format : format, font : barcodeFontFamily, displayValue : showNumber, height : 100 + deltaHeight, flat : isFlat } );
                // フォントを適用
                this.applyOcrFont(svg);
            }
            else
            {
                svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                JsBarcode(svg, text, { format : format, font : barcodeFontFamily, displayValue : showNumber, height : 100 + deltaHeight, flat : isFlat } );
            }
            // Element -> Tag
            var tag = HtmlHelper.convertElementToTag(svg);
            // 補正する
            tag = this.fixSvgTag(barcodeType, tag, showNumber);
            // Tag -> base64
            var base64 = ImageHelper.convertSVGTagToBase64(tag);
            return base64;
        }
        catch(e)
        {
            DebugHelper.trace(e);
            return "";
        }
    }

    public static isGS1Barcode(barcodeType : number)
    {
        return barcodeType == 9 || barcodeType == 10 || barcodeType == 12;
    }

    // GS1バーコードを生成して、base64文字列で画像を返す
    // 9: GS1(標準)
    // 10: GS1(拡張)
    // 12: GS1-128
    public static createGS1(barcodeType : number, text : string, showNumber : boolean, width : number, height : number)
    {
        var base64 = "";
        try
        {
            var canvas = document.createElement("canvas");
            var bcid = "";
            if(barcodeType == 9)
            {
                bcid = 'databaromni';
            }
            else if(barcodeType == 10)
            {
                bcid = 'databarexpanded';
            }
            else if(barcodeType == 12)
            {
                bcid = 'gs1-128';
            }
            bwipjs(canvas,
            {
                bcid:   bcid,
                text:   text,
                scale:  8
            },
            (err, cvs) =>
            {
                if(err)
                {
                    DebugHelper.trace("GS1 generate error.");
                }
                else
                {
                    // fontを用いないので、ここで受け取る必要はない
                }
            });

            base64 = canvas.toDataURL('image/png');
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        if(this.isBlankPng(base64)) base64 = "";
        
        return base64;
    }

    // 一部のバーコードに対して特殊な修正処理を入れる
    private static fixSvgTag(barcodeType : number, tag : string, showNumber : boolean) : string
    {
        var newTag = "";
        try
        {
            if(barcodeType == 7 && showNumber)
            {
                // CODE39(文字あり)
                // タグ解析
                var parser = new DOMParser();
                var doc = parser.parseFromString(tag, "image/svg+xml");
                // SVGタグ取得
                var svgEle = doc.getElementsByTagName("svg")[0];
                // 幅の値取得
                var rect = svgEle.viewBox.baseVal;
                var width = rect.width;
                // バーコードの両端にマージンがあるので実際の幅はそれを引く
                width = Math.max(width - this.BARCODE_MARGIN * 2, 0);
                // テキストタグ取得
                var textEle = doc.getElementsByTagName("text")[0];
                // テキストにスタートキャラクタ、ストップキャラクタとして * 追加
                textEle.textContent = "*" + textEle.textContent + "*";
                // テキスト幅の合計
                var totalTextWidth = textEle.textContent.length * this.BARCODE_FONTSIZE * Const.FONT_WIDTH_RATION_OCRB;
                DebugHelper.trace(totalTextWidth);
                // 文字の両端に必要なマージンを計算
                var textLen = Math.max(textEle.textContent.length, 1);
                var margin = (width - totalTextWidth) / (textLen * 2);
                // テキストの均等
                textEle.setAttribute("textLength", (width - margin * 2) + "");
                var serializer = new XMLSerializer();
                newTag = serializer.serializeToString(doc);      
            }
            else
            {
                newTag = tag;
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
            newTag = tag;
        }

        return newTag;
    }

    private static isBlankPng(base64 : string)
    {
        return base64 == "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACWCAYAAABkW7XSAAAEYklEQVR4Xu3UAQkAAAwCwdm/9HI83BLIOdw5AgQIRAQWySkmAQIEzmB5AgIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlAABg+UHCBDICBisTFWCEiBgsPwAAQIZAYOVqUpQAgQMlh8gQCAjYLAyVQlKgIDB8gMECGQEDFamKkEJEDBYfoAAgYyAwcpUJSgBAgbLDxAgkBEwWJmqBCVAwGD5AQIEMgIGK1OVoAQIGCw/QIBARsBgZaoSlACBB1YxAJfjJb2jAAAAAElFTkSuQmCC";
    }

	// テキストの修正
	// 先頭にBOMがあったら削除する
	public static removeStartBOMOfText(text : string)
	{
		let result = "";
		for(let i = 0; i < text.length; ++i)
		{
			let ch = text.charCodeAt(i);
			if(ch == 65279)
			{
				// BOM
				DebugHelper.trace("delete bom from: " + text);
			}
			else
			{
				// 文字列追加
				result += String.fromCharCode(ch);
			}
		}
		DebugHelper.trace("removeStartBOMOfText: " + text + " -> " + result);
		return result;
	}

    // テキストの修正
    // 最後のスペースを削除する
    public static removeEndSpaceOfText(text : string)
    {
        var result = text;
        for(var i = text.length - 1; i >= 0; --i)
        {
            if(text.substr(i, 1) == " ")
            {
                result = text.substr(0, i);
            }
            else
            {
                break;
            }
        }

        return result;
    }

    public static calcBarcodeSize(barcodeType : number, text : string, showNumber : boolean, width : number, height : number)
    {
        if(width <= 0 || height <= 0) { return { width : 0, height : 0 }; }

        try
        {
            // 物流コードの桁数チェック
            if(barcodeType == 3)
            {
                // ITF-16
                if(text.length == 16 || text.length == 15) 
                {
                    // チェックデジットを計算
                    var digit = this.calcCheckDigitModulus10Weight3(text.substr(0, 15));
                    text = text.substr(0, 15) + digit;
                }
                else
                {
                    return { width : 0, height : 0 };
                }
            }
            else if(barcodeType == 4)
            {
                // ITF-6
                if(text.length == 6 || text.length == 5) 
                {
                    // チェックデジットを計算
                    var digit = this.calcCheckDigitModulus10Weight3(text.substr(0, 5));
                    text = text.substr(0, 5) + digit;
                }
                else
                {
                    return { width : 0, height : 0 };
                }
            }
            var JsBarcode = require('jsbarcode');
            var canvas = document.createElement("canvas");
            var format = CodeHelper.getFormatFromBarcodeType(barcodeType);
            var barcodeFontFamily = Const.FONT_FAMILY_OCRB;
            JsBarcode(canvas, text, { format : format, font : barcodeFontFamily, displayValue : showNumber, height : 100 } );
            var codeWidth = canvas.width;
            var codeHeight = canvas.height;
            var needHeight = height * codeWidth / width;
            var deltaHeight = needHeight - codeHeight;
            return { width : codeWidth, height : 100 + deltaHeight };
        }
        catch(e)
        {
            DebugHelper.trace(e);
            return { width : 0, height : 0 };
        }
    }

    // チェックデジットの計算
    private static calcCheckDigitModulus10Weight3(line : string)
    {
        // 奇数位置の数値
        var odd = 0;
        var even = 0;
        for(var i = line.length - 1; i >= 0; --i)
        {
            var char = line.substr(i, 1);
            if(parseInt(char) != NaN)
            {
                if(i % 2 == 0)
                {
                    odd += parseInt(char);
                }
                else
                {
                    even += parseInt(char);
                }
            }
        }

        // 奇数位置 * 3 + 偶数位置
        var sum = odd * 3 + even;
        // この数値の1の位の数値
        var sum1 = sum % 10;
        // 10から引く
        var digit = 10 - sum1;
        return digit;
    }

    public static getFormatFromBarcodeType(barcodeType : number)
    {
        var format = "auto";
        if(barcodeType == 0) { format = "EAN13"; }
        else if(barcodeType == 1) { format = "EAN8"; }
        else if(barcodeType == 2) { format = "ITF14"; }
        else if(barcodeType == 3) { format = "ITF"; }
        else if(barcodeType == 4) { format = "ITF"; }
        else if(barcodeType == 5) { format = "ITF"; }
        else if(barcodeType == 6) { format = "codabar"; }
        else if(barcodeType == 7) { format = "CODE39"; }
        else if(barcodeType == 8) { format = "CODE128"; }
        else if(barcodeType == 11) { format = "EAN13"; }
        return format;
    }

    // QRコードを生成して、base64文字列で画像を返す
    // errorCorrection
    // 0: L
    // 1: M
    // 2: Q
    // 3: H
    public static createQRcode(text : string, version : number, errorCorrection : number, margin : boolean)
    {
        var image = "";
        try
        {
            var qrcode = require('qrcode-generator');
            var qr = qrcode(version, CodeHelper.getErrorCorrectionString(errorCorrection));
            // 日本語対応
            qrcode.stringToBytesFuncs['SJIS'] = this.stringToShiftJisArray;
            
            var qrMode = this.getQRMode(text);
            DebugHelper.trace("QRCode Mode : "+ qrMode);
            if(qrMode == "Byte")
            {
                // SJISでエンコード
                text = Encoding.convert(text, "SJIS");
                DebugHelper.trace("text convert -> " + text);
            }

            qr.addData(text, qrMode);
            qr.make();
            var svgTag = margin ? qr.createSvgTag() : qr.createSvgTag(2, 0);
            image = ImageHelper.convertSVGTagToBase64(svgTag);
            DebugHelper.trace(image)
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        return image;
    }

    private static getQRMode(text : string)
    {
        if(this.isAlphaNum(text))
        {
            if(this.isNumber(text))
            {
                return 'Numeric';
            }
            else
            {
                return 'Alphanumeric';
            }
        }
        else if(this.isKanji(text))
        {
            return 'Kanji';
        }
        else
        {
            return 'Byte';
        }
    }

    private static isAlphaNum(text : string)
    {
        // 小文字を含めない
        return text.match(/^[A-Z0-9]+$/);
    }

    private static isNumber(text : string)
    {
        return text.match(/^[0-9]+$/);
    }

    private static isKanji(text : string)
    {
        try
        {
            // 判定はShift-Jisで行う
            let sjisArray = this.stringToShiftJisArray(text);
            // 文字コードで漢字かどうか判定する
            var idx = 0;
            while(idx + 1 < sjisArray.length)
            {
                let c = ((0xff & sjisArray[idx]) << 8) | (0xff & sjisArray[idx + 1]);
                if(!(0x8140 <= c && c <= 0x9FFC) && !(0xE040 <= c && c <= 0xEBBF))
                {
                    return false;
                }

                idx += 2;
            }

            if(idx < sjisArray.length) return false;

            return true;
        }
        catch(e)
        {
            DebugHelper.trace("isKanji Error " + e);
            return false;
        }
    }

    private static stringToShiftJisArray(text : string)
    {
        // string -> [unicode]
        let unicodeArray : Array<number> = [];
        for(let i = 0; i < text.length; ++i)
        {
            unicodeArray.push(text.charCodeAt(i));
        }
        // [unicode] -> [sjis]
        let sjisArray : Array<number> = Encoding.convert(unicodeArray, {
            to : 'SJIS',
            from : 'UNICODE'
        });
        return sjisArray;
    }

    public static getErrorCorrectionString(errorCorrection : number)
    {
        var str = "L";
        if(errorCorrection == 0) { str = "L"; }
        else if(errorCorrection == 1) { str = "M"; }
        else if(errorCorrection == 2) { str = "Q"; }
        else if(errorCorrection == 3) { str = "H"; }
        return str;
    }

    // OCRフォントを適用する
    private static applyOcrFont(svg : SVGSVGElement)
    {
        // <defs> をsvgに追加する。
        var xmlDoc = new DOMParser().parseFromString('<xml></xml>', 'application/xml');
        var defs = xmlDoc.createElementNS('http://www.w3.org/2000/svg', 'defs');
        svg.appendChild(defs);
        // defsにCDATAとしてstyleSheetを追加する。
        // styleSheetにはwoffファイルをbase64変換したものを設定し、font-family="ocrBarcode"として定義する。
        var cdataStr = this.getOcrFontFace();
        var cdata = xmlDoc.createCDATASection(cdataStr);
        var style = xmlDoc.createElementNS("http://www.w3.org/2000/svg", "style");
        style.type = "text/css";
        style.appendChild(cdata);
        defs.appendChild(style);
    }

    public static getOcrFontFace()
    {
        return '@font-face {font-family: "ocrBarcode";src: url("data:application/font-woff;charset=utf-8;base64,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");}';
    }
}